import { render } from "./UpdateTeamNameForm.vue?vue&type=template&id=c1389aa0"
import script from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"
export * from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__